import React from 'react';

import { usePermissions } from 'models/user/permissions';
import { locationOrigin } from '../../utils/utils';

import { Button, StopPropagation } from '@weezevent/nacre';

import { WeezAccessName, WeezTicketName, WeezPayName, WeezTargetName, WeezCrewName } from 'images';

import css from './bo-item.module.css';

const PRODUCTS = {
    ticket: { logo: WeezTicketName, disabled: false },
    access: { logo: WeezAccessName, disabled: false },
    pay: { logo: WeezPayName, disabled: false },
    target: { logo: WeezTargetName, disabled: false },
    crew: { logo: WeezCrewName, disabled: false }
};

const BoItems = ({ organizationId, eventId }) => {
    const user = usePermissions();

    const items = React.useMemo(() => {
        const products = Object.entries(PRODUCTS).map(([name, { logo, disabled }]) => {
            return { logo, name, display: user.canDisplayProduct(name.toUpperCase(), organizationId), disabled };
        });

        return products.filter(it => it.display);
    }, [user, organizationId]);

    if (!items.length) {
        return null;
    }

    return (
        <StopPropagation>
            <div className={css['bo-items']}>
                {items.map((bo, index) => (
                    <BoItem key={index} logo={bo.logo} orgaId={organizationId} eventId={eventId} name={bo.name} disabled={bo.disabled} />
                ))}
            </div>
        </StopPropagation>
    );
};

const BoItem = React.memo(({ logo, name, orgaId, eventId, disabled = false }) => {
    const handleRedirect = React.useCallback(
        event => {
            const window_origin = locationOrigin();
            let path = name === 'pay' ? `${name}/#!/${orgaId}` : `${name}/O${orgaId}`;

            if (name === 'ticket' && eventId) {
                path += `/E${eventId}`;
            }

            // metaKey is for the command key on Mac
            if (event.ctrlKey || event.metaKey) {
                window.open(`${window_origin}/${path}`, '_blank', 'noopener noreferrer');
            } else {
                window.location.assign(`${window_origin}/${path}`);
            }
        },
        [name, orgaId]
    );

    return (
        <Button disabled={disabled} onClick={handleRedirect} className={css['bo-item']} style={{ backgroundColor: `var(--button-alpha-${name}-color)` }}>
            <img src={logo} className={css['bo-item-logo']} alt={'logo'} />
        </Button>
    );
});

export default BoItems;
